import { reviewFeedFilters } from "../../lib/reviewFeed";
import { parseReviewSearch, type ReviewSearch } from "../../lib/routerSearch";
import { useTypedNavigate } from "../../lib/typedRouter";
import {
  withWorkingScopeSearch,
  type WorkingScopeSearch,
} from "../../lib/workingScope";
import {
  parseReviewMarkerSearch,
  type ReviewMarkerSearch,
} from "../review/reviewMarkerData";

export function useReviewReturn(feed?: string) {
  const navigate = useTypedNavigate<
    WorkingScopeSearch & (ReviewMarkerSearch | ReviewSearch)
  >();
  return () => {
    const search: Record<string, unknown> = Object.fromEntries(
      new URLSearchParams(feed),
    );
    const markerId = reviewFeedFilters(feed ?? "").marker_id;
    if (markerId) {
      void navigate({
        to: "/review/$markerId",
        params: { markerId },
        search: withWorkingScopeSearch(parseReviewMarkerSearch)(search),
      });
    } else {
      search.needs_review ??= "any";
      void navigate({
        to: "/review",
        search: withWorkingScopeSearch(parseReviewSearch)(search),
      });
    }
  };
}
